import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { workflowSteps } from '../../data/content';
export function HowItWorks() {
  return <section className="bg-canvas px-5 py-14 md:py-20" data-id="element-203" data-mp="2sqg83a8k23t">
      <div className="mx-auto max-w-5xl" data-id="element-204" data-mp="2q48o3nchmll">
        <SectionHeading title="See How the Blueprint Fits Into Your Workflow" data-id="element-205" data-mp="3txyv24svbolk" />

        <ol className="mt-10 grid gap-4 md:grid-cols-4" data-id="element-206" data-mp="bsvmub7luwgx">
          {workflowSteps.map((s, i) => <li key={s.title} className="flex gap-4 rounded-2xl bg-white p-5 ring-1 ring-navy/5 md:flex-col md:gap-3" data-id="element-207" data-mp="6tsk4xf3l2c4" data-mpi={i}>
              <span className="text-3xl font-extrabold leading-none text-gold-dark md:text-4xl" data-id="element-208" data-mp="lj8865n8uto4">0{i + 1}</span>
              <div data-id="element-209" data-mp="gkn4fw8s9rux">
                <h3 className="text-base font-extrabold leading-tight text-navy md:text-lg" data-id="element-210" data-mp="gk3yldweqtx9">{s.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-navy/75" data-id="element-211" data-mp="ujmsp2sdw4qk">{s.text}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-212" data-mp="24cpiibssyxvw">
          A practical workflow you can reference whenever postoperative wound monitoring is part of your professional
          responsibilities.
        </p>

        <SectionCTA label="Start Today — $27" data-id="element-213" data-mp="2deys8zg8yn88" />
      </div>
    </section>;
}